module.exports = __webpack_public_path__ + "static/media/apple.8687ebe8.gif";